// import action types
import { ADD_URLS, INITIALISE_URLS, CLEAR_USER_SESSION } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @desc A Redux Reducer to manage state of the Redux Store
 * @param {object} [state={}] - Current state of the Redux Store at given state key
 * @param {object} action - Redux **action** object with **event name** and **payload**
 * @example
 * import { addUrls } from 'reducers/addUrls';
 */
export const addUrls = ( state = {}, action ) => {
    const { type, payload } = action;

    switch( type ) {
        case ADD_URLS:
			return { ...state, ...payload };
		case INITIALISE_URLS:
			return {
				...state,
				...CONFIG.endpoints.authentication,
				...CONFIG.endpoints.componentList,
				...CONFIG.endpoints.componentInfo
			};
		case CLEAR_USER_SESSION:
            return {};
        default:
            return state;
    }
};
